import { useMutation, useQueryClient } from 'react-query'
import companyApi from './actions'
import { companiesKeys } from './constants'

const useCompaniesMutations = () => {
  const queryClient = useQueryClient()

  const mutationOptions = {
    onSuccess: async () => {
      await queryClient.invalidateQueries(companiesKeys.root)
    },
  }

  const createCompany = useMutation(companyApi.createCompany, mutationOptions)

  const updateCompany = useMutation(companyApi.updateCompany, mutationOptions)

  const deleteCompany = useMutation(companyApi.deleteCompany, mutationOptions)

  const createCompanyPartner = useMutation(
    companyApi.createCompanyPartner,
    mutationOptions,
  )

  const updateCompanyPartner = useMutation(
    companyApi.updateCompanyPartner,
    mutationOptions,
  )

  const deleteCompanyPartner = useMutation(
    companyApi.deleteCompanyPartner,
    mutationOptions,
  )

  return {
    createCompany,
    updateCompany,
    deleteCompany,
    createCompanyPartner,
    deleteCompanyPartner,
    updateCompanyPartner,
  }
}

export default useCompaniesMutations
